import { isDevelopment } from "utils/fn";

export const IS_DEV_ENV =
  process.env.NODE_ENV === "development" || isDevelopment();
